(function () {

    'use strict';

    angular.module('libphonenumber', [])
        .provider('libphonenumber', LibphonenumberProvider);

    LibphonenumberProvider.$inject = [
        '$windowProvider'
    ];
    function LibphonenumberProvider($windowProvider) {
        var $window = $windowProvider.$get();

        return {
            $get: function () {
                return $window.libphonenumber || {};
            }
        };
    }
})();
